import { cn } from "@/lib/utils";
import { DeepAnalysisType, useDeepAnalysisStore } from "@/stores/ui/useDeepAnalysisStore";
import { Dialog, DialogContent, DialogOverlay, DialogPortal, DialogTitle } from "../atomic/Dialog";
import { ChatAnalysis } from "./chat/ChatAnalysis";
import { DeepAnalysisHeader } from "./deep-analysis/DeepAnalysisHeader";
import { VocSearch } from "./VocSearch";

export const DeepAnalysisModal = () => {
  const {
    isDeepAnalysisModalOpen,
    setIsDeepAnalysisModalOpen,
    deepAnalysisType,
    setDeepAnalysisType,
  } = useDeepAnalysisStore();

  return (
    <Dialog open={isDeepAnalysisModalOpen} onOpenChange={setIsDeepAnalysisModalOpen}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className={cn(
            "max-w-[85vw] h-[80vh] p-0 border-none flex flex-col bg-[#F5F8FF]",
            "transition-all duration-300",
          )}
        >
          <DialogTitle className="sr-only">Deep Analysis</DialogTitle>
          <DeepAnalysisHeader
            onClose={() => setIsDeepAnalysisModalOpen(false)}
            setAnalysisType={setDeepAnalysisType}
            analysistype={deepAnalysisType}
          />

          {deepAnalysisType === DeepAnalysisType.VOC_SEARCH && <VocSearch />}
          {deepAnalysisType === DeepAnalysisType.CHAT && <ChatAnalysis />}
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};
